module.exports = "<div layout=\"column\" class=\"md-warning\" flex>\n  <f-toolbar></f-toolbar>\n  <div class=\"content not-found\" flex layout=\"column\" layout-align=\"center center\">\n    <div class=\"icon\">\n      <i class=\"fa fa-warning\"></i>\n    </div>\n    <h1>Oh no!<br /><small>That page doesn't exist.</small></h1>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./routes/errors/not-found/tpl.html
// module id = 1172
// module chunks = 0